<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="this.$l('form_label_package_no')||'包装编号'">
            <el-input v-model="formData.packageNo" readonly size="small">
              <el-button
                :disabled="disabled"
                slot="append"
                icon="el-icon-finished"
                @click="() => (dialogVisible = true)"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="this.$l('INDEX.table_label_price')||'单价'" prop="unitPrice">
            <el-input-number
              v-model="formData.unitPrice"
              clearable
              size="small"
              style="width:100%"
              :min="0"
              :step="0.01"
              :precision="2"
              controls-position="right"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="this.$l('form_label_qty')||'数量'">
            <el-input-number
              v-model="formData.qty"
              clearable
              size="small"
              style="width:100%"
              :min="0"
              :step="1"
              :precision="0"
              controls-position="right"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="this.$l('INDEX.order_goods_label_subAmount')||'小计金额'">
            <el-input-number
              v-model="formData.subAmount"
              clearable
              size="small"
              style="width:100%"
              :min="0"
              :step="0.01"
              :precision="2"
              controls-position="right"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="this.$l('form_label_factory_package_number')||'工厂包装编号'">
            <el-input
              v-model="formData.factoryNumber"
              type="text"
              clearable
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="this.$l('form_label_package_specification')||'包装规格'">
            <el-input
              v-model="formData.packageDesc"
              type="text"
              clearable
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="this.$l('INDEX.table_label_remarks')||'备注说明'">
            <el-input
              v-model="formData.remark"
              type="textarea"
              clearable
              size="small"
              rows="2"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <choose-material-dialog
        :title="$l('INDEX.material_choose_title') || '添加物料信息'"
        :visible.sync="dialogVisible"
        :productLine="formData.productLine"
        :detailMaterialCategoryCode="formData.detailMaterialCategoryCode"
        :mainMaterialCategoryCode="formData.mainMaterialCategoryCode"
        type="radio"
        @confirm="onMaterialConfirm"
      />
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    purchasePackageDetailCode: String,
    purchasePackageCode: String,
    disabled: Boolean,
  },
  data() {
    return {
      dialogVisible: false,
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.purchasePackageDetailCode) return
      this.$api
        .purchasePackageDetDeatilApi({
          purchasePackageDetailCode: this.purchasePackageDetailCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const packageNo = this.formData.packageNo
      if (!packageNo) {
        this.$message.error(this.$l('table_label_Package_no_cannot_be_empty')||"包装编号不能为空！")
        return
      }

      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      //根据不同的操作调用不同接口
      let saveApi
      if (this.purchasePackageDetailCode) {
        saveApi = this.$api.purchasePackageDetailModifyApi({
          ...this.formData,
          purchasePackageCode: this.purchasePackageCode,
        })
      } else {
        saveApi = this.$api.purchasePackageDetailAddApi({
          ...this.formData,
          purchasePackageCode: this.purchasePackageCode,
        })
      }
      saveApi
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          })
          this.$emit("close")
          this.$emit("reload")
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    onMaterialConfirm(data) {
      if (!data) return
      this.formData.packageCode = data.materialCode
      this.formData.packageNo = data.materialNo
      this.formData.packageName = data.materialName
    },
  },
}
</script>
